/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Graph': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<defs><path pid="0" d="M6.5 8A1.5 1.5 0 018 9.5V24H5V9.5A1.5 1.5 0 016.5 8zm15 2a1.5 1.5 0 011.5 1.5V24h-3V11.5a1.5 1.5 0 011.5-1.5zm-5 3a1.5 1.5 0 011.5 1.5V24h-3v-9.5a1.5 1.5 0 011.5-1.5zm-5-10A1.5 1.5 0 0113 4.5V24h-3V4.5A1.5 1.5 0 0111.5 3z" id="svgicon_Graph_a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_Graph_b" _fill="#fff"><use xlink:href="#svgicon_Graph_a"/></mask><g mask="url(#svgicon_Graph_b)" _fill="#CFCFCF"><path pid="1" d="M0 0h28v28H0z"/></g></g>'
  }
})
